module.exports = __webpack_public_path__ + "img/choujiang-bg.1ff02ec9.png";